<template>
  <div id="accountSettings">
    <div class="right column" style="width: 100%;">
      <div class="right-content">
        <div class="top">
          <img src="../../assets/icon/qrc.png" alt />

          <span style="margin: 0 10px;color: #eee">|</span>
          <span>创建店铺</span>
          <div class="floatRight">
            <!-- <span>{{$store.state.shopInformation.shopTel}}</span> -->
            <span class="exit" @click="dialogVisible = true">退出</span>
          </div>
          <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
            <span>确定退出用户吗</span>
            <span slot="footer" class="dialog-footer" style="z-index:2100">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="exit">确 定</el-button>
            </span>
          </el-dialog>
        </div>
        <div class="content">
          <div @click="lastText" class="lastStep row alignCenter">
            <img src="../../assets/icon/syb.png" alt />
            <div class="lastText">上一步</div>
          </div>
          <!-- 表单提交 -->
          <div class="center" style="margin-top:30px">
            <div class="form">
              <el-form
                ref="ruleForm"
                hide-required-asterisk
                :model="ruleForm"
                :rules="rules"
                label-width="100px"
              >
                <el-form-item label="商家名称：" prop="name">
                  <el-input size="small" v-model="ruleForm.name" placeholder="请输入商家名称"></el-input>
                </el-form-item>
                <!-- <el-cascader size="small" ref="location"  id="address" v-model="form.name" placeholder="点击选择" :options="arr" @change="handleChange"></el-cascader> -->
                <el-form-item prop="search">
                  <el-input size="small" id="address" v-model="ruleForm.search" placeholder="点击选择"></el-input>
                  <el-button type="primary" @click="btn" id="btn" class="button1 amend">搜索地图</el-button>
                </el-form-item>
                <el-form-item label="地图定位：">
                  <div id="allmap" class="allmap"></div>
                </el-form-item>
                <el-form-item label="详细地址" prop="site">
                  <el-input size="small" v-model="ruleForm.site" placeholder="请输入详细门店信息"></el-input>
                </el-form-item>
                <el-form-item label="电话号码">
                  <el-input size="small" v-model="ruleForm.shopTel" placeholder="请输入电话号码"></el-input>
                </el-form-item>
                <!-- <el-form-item label="营业时间">
                  <el-time-select
                  size="small"
                    placeholder="起始时间"
                    v-model="startTime"
                    :picker-options="{ start: '00:00',step: '00:15', end: '24:00'}"
                    style="width:100px"
                  ></el-time-select></el-form-item>
                <el-form-item>
                <el-time-select
                  
                  size="small"
                    placeholder="结束时间"
                    v-model="endTime"
                    :picker-options="{ start: '00:00',step: '00:15', end: '24:00', minTime: startTime}"
          
                  ></el-time-select>
                </el-form-item>-->
                <el-form-item label="主营类目" prop="region">
                  <el-cascader
                    size="small"
                    v-model="ruleForm.region"
                    :options="options"
                    @change="handleChange"
                  ></el-cascader>
                </el-form-item>
                <el-form-item>
                  <div class="main-bottom">
                    <el-checkbox v-model="writeAgree">
                      <span class="text">已阅读同意</span>
                      <a href="javascript:;">《钱如潮服务协议》</a>和
                      <a href="javascript:;">《担保交易服务协议》</a>
                    </el-checkbox>
                  </div>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    class="button1"
                    @click="submitForm('ruleForm')"
                    :disabled="successButton"
                  >创建店铺</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BMap from "BMap";
import cityArr from "../../assets/citys.json";
import cityData from "../../assets/cityData.json";
export default {
  name: "accountSettings",

  data() {
    return {
      startTime: "",
      endTime: "",
      successButton: false, //创建店铺按钮禁用
      writeAgree: true, //阅读同意
      shopCategoryId: "",
      provinceId: "",
      cityId: "",
      districtId: "",
      longitude: "",
      latitude: "",
      cityData2: [], //区县数组
      cityData1: [], //省份数组
      cityData3: [], //城市数组
      arr: [],
      value: [],
      options: [],
      dialogVisible: false, //控制退出提示弹窗
      userList: "", //用户信息
      //用户表单信息
      ruleForm: {
        name: "",
        region: "",
        site: "",
        search: "",
        shopTel: ""
      },
      //表单验证规则
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        search: [{ required: true, message: "请输入省市区", trigger: "blur" }],
        site: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
        region: [
          { required: true, message: "请选择主营类目", trigger: "change" }
        ]
      },
      imageUrl: require("../../assets/icon/mdzp1.png") //门店照片上传图案
    };
  },

  watch: {
    writeAgree: function() {
      if (this.writeAgree) {
        this.successButton = false;
      } else {
        this.successButton = true;
      }
    }
  },

  created() {
    var that = this;
    let userList = this.getCookie("userList");
    var a = JSON.parse(userList);
    console.log(a, "userList");
    this.userList = a;

    //请求店铺分类
    that.axios
      .get(that.url + "qrcapi/Shop_shopCategoryList", {
        params: {}
      })
      .then(function(res) {
        if (res.data.code == 1) {
          console.log(res, "店铺分类");
          for (let i in res.data.data) {
            that.options.push({
              label: res.data.data[i].categoryName,
              value: res.data.data[i].shopCategoryId,
              children: []
            });
            that.hopCategoryList(res.data.data[i].shopCategoryId, i);
          }
        } else {
          that.$message.error("店铺分类请求失败");
        }
      })
      .catch(function(error) {
        alert("网络错误，不能访问");
        console.log(error);
      });
  },

  mounted() {
    this.arr = cityArr;

    let arr = [];
    for (let i in cityData) {
      this.cityData1.push(cityData[i]);
      for (let a in cityData[i].sub) {
        this.cityData3.push(cityData[i].sub[a]);
        for (let e in cityData[i].sub[a].sub) {
          arr.push(cityData[i].sub[a].sub[e]);
        }
      }
    }
    this.cityData2 = arr;
    console.log(this.options, "11");
    var that = this;
    var map = new BMap.Map("allmap"); // 创建地图实例
    var point = new BMap.Point(120.64207, 28.02191); // 创建点坐标
    map.centerAndZoom(point, 12); // 初始化地图，设置中心点坐标和地图级别
    map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
    map.addControl(new BMap.NavigationControl()); //左上角，添加默认缩放平移控件
    map.addControl(new BMap.ScaleControl()); // 左上角，添加比例尺
    map.addControl(new BMap.OverviewMapControl());
    // map.addControl(new BMap.MapTypeControl());
    map.setCurrentCity("温州"); // 仅当设置城市信息时，MapTypeControl的切换功能才能可用
    function myFun(result) {
      var cityName = result.name;
      map.setCenter(cityName);

      // alert("当前定位城市:" + cityName);
      that.ruleForm.search = cityName;
      that.setPlace(cityName);
    }
    var myCity = new BMap.LocalCity();
    myCity.get(myFun);
    // map.setMapStyle({ style: "" }); //地图风格
  },

  methods: {
    // 选择营业时间
    timeChange(e) {
      console.log(e, "time");
    },
    // 地图搜索按钮事件
    btn() {
      this.setPlace(this.ruleForm.search);
    },
    handleChange(value) {
      this.shopCategoryId = value;
      console.log(this.shopCategoryId, "value");
      //检索id 的中文
      // console.log(this.options.indexOf(value));
      // for (let i in this.options) {
      //   if (this.options[i].value == value[0]) {
      //     console.log(this.options[i].label);
      //   }
      // }
    },
    hopCategoryList(shopCategoryId, index, pageNo) {
      var that = this;
      that.axios
        .get(that.url + "qrcapi/Shop_shopCategoryList", {
          params: {
            shopCategoryId: shopCategoryId,
            pageNo: pageNo
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            for (let i in res.data.data) {
              that.options[index].children.push({
                label: res.data.data[i].categoryName,
                value: res.data.data[i].shopCategoryId
              });
            }
            // console.log(res, "二级分类");
          } else {
            that.$message.error("店铺分类请求失败");
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    // 控制门店照片上传
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      console.log(res, file);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    //表单提交
    submitForm(formName) {
      var that = this;
      var userId = this.userList.id; //用户Id
      var shopName = this.ruleForm.name; //店铺名称
      var shopAddress = this.ruleForm.site; //地址
      var shopTel = this.ruleForm.shopTel; //电话号码
      var shopCategoryId = this.ruleForm.region[1]; //分类
      var provinceId = this.provinceId; //省份ID
      var cityId = this.cityId; //城市ID
      var districtId = this.districtId; //区、县ID
      var longitude = this.longitude; //经度
      var latitude = this.latitude;
      var sessionId = this.userList.sessionId;
      console.log(
        userId,
        shopName,
        shopAddress,
        shopCategoryId,
        provinceId,
        cityId,
        districtId,
        longitude,
        latitude
      );
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.request
            .post("qrcapi/Shop_modifyShopInfo", {
              sessionId: sessionId,
              userId: userId, //用户Id
              shopName: shopName, //店铺名称
              shopAddress: shopAddress, //地址
              shopCategoryId: shopCategoryId, //分类
              provinceId: provinceId, //省份ID
              cityId: cityId, //城市ID
              districtId: districtId, //区、县ID
              longitude: longitude, //经度
              latitude: latitude,
              shopLogo:
                "https://api.yichengshi.cn/ImageServer/img/A/YMXXXX3996-eiczfxwtyk_YM0000.png",
              shopTel: shopTel,
              coodinateSystemType: 2
              // businessHours: "10:00 - 12:12"
            })
            .then(res => {
              if (res.code == 1) {
                console.log(res, "店铺建立或者修改");
                this.request
                  .get("qrcapi/Shop_shopInfo", {
                    userId: userId,
                    sessionId: sessionId
                  })
                  .then(function(res) {
                    console.log(res, "店铺信息");
                    that.setCookie("shopInformation", JSON.stringify(res.data));
                    that.$store.state.shopInformation = res.data;
                    if (res.code == 1) {
                      //  that.$message.error("未创建店铺");
                    }
                  })
                  .catch(function(error) {
                    alert("网络错误，不能访问");
                    console.log(error);
                  });
                this.$message({
                  message: "创建成功",
                  type: "success"
                });
                this.$router.push("/home");
              } else if (res.code == 2) {
                this.$router.push("/");
              } else {
                that.$message.error(res.msg);
              }
            })
            .catch(function(error) {
              alert("网络错误，不能访问");
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //退出跳转
    exit() {
      var that = this;
      var userId = this.userList.id; //用户Id
      var sessionId = this.userList.sessionId;
      console.log(userId, sessionId, "sessionId");
      this.axios
        .get(this.url + "qrcapi/Login_loginOut", {
          params: {
            userId: userId,
            sessionId: sessionId
          }
        })
        .then(function(response) {
          if (response.data.code == 1) {
            that.$message({
              type: "success",
              message: response.data.msg
            });
            that.dialogVisible = false;
            that.$router.push("/");
          } else {
            alert(response.data.msg);
          }
          console.log(response);
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    // 返回山一页
    lastText() {
      this.$router.go(-1);
    },
    // 跳转修改密码
    hrefPassword() {
      this.$router.push("/changePassword");
    }
  }
};
</script>

<style scoped>
.floatRight {
  position: absolute;
  right: 20px;
  font-size: 10px;
}
.top {
  width: 900px;
  border-bottom: 2px solid #eee;
  padding: 30px 0 10px 0;
  display: flex;
  align-items: center;
  position: relative;
}
.right {
  width: 60%;
  height: 100%;
  float: right;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.right-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.exit {
  color: #60b4f0;
  cursor: pointer;
}
.content {
  width: 900px;
}
.lastStep {
  font-size: 12px;
  color: #4da1f0;
  width: 100%;
  cursor: pointer;
  margin-top: 15px;
}
.lastStep img {
  width: 17px;
  height: 5px;
}
.lastText {
  margin-left: 10px;
}
.form {
  width: 600px;
}
.amend {
  position: absolute;
  right: 65px;
  top: 10px;
}
.button1 {
  height: 30px;
  width: 80px;
  padding: 0;
}
.allmap {
  height: 290px;
  width: 440px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/creatStore.vue